export default __webpack_public_path__ + "static/media/portadavideoseguimiento2.aafb905d.png";